import { useFormikContext } from "formik";
import { FC, useMemo } from "react";
import {
	RegistrationFormSectionResourceTypeDefaultSection,
	RuleGuestAttributeResourceTypeDataField,
	RuleResource,
} from "../../shared/types";
import { BlockRenderer } from "../BlockRenderer";
import { useHiddenDataFieldIdsInSection } from "../provider/registrationFormProviderContext";
import { RegistrationDataField } from "../RegistrationDataField";

interface Props {
	stepId: number;
	section: RegistrationFormSectionResourceTypeDefaultSection;
	validationRules: RuleResource<RuleGuestAttributeResourceTypeDataField>[];
}

export const RegistrationDefaultSection: FC<Props> = ({ section, stepId, validationRules }) => {
	const { values: stepFormValues } = useFormikContext<Record<number | string, unknown>>();
	const hiddenDataFieldIds = useHiddenDataFieldIdsInSection(stepFormValues, stepId, section);

	const validationRuleMap = useMemo(
		() =>
			validationRules.reduce(
				(acc, cur) => ({
					...acc,
					[cur.guestAttribute.dataField.id]: [...(acc[cur.guestAttribute.dataField.id] ?? []), cur],
				}),
				{} as Record<number, RuleResource<RuleGuestAttributeResourceTypeDataField>[]>,
			),
		[validationRules],
	);

	return (
		<>
			{section.children.map((dataFieldOrBlock) => {
				if (dataFieldOrBlock.entityType === "block") {
					return (
						<BlockRenderer
							key={`${dataFieldOrBlock.entityType}_${dataFieldOrBlock.block.id}`}
							block={dataFieldOrBlock.block}
							sectionId={section.id}
						/>
					);
				} else if (!hiddenDataFieldIds.includes(dataFieldOrBlock.guestAttribute.dataField.id)) {
					return (
						<RegistrationDataField
							name={`${dataFieldOrBlock.guestAttribute.dataField.id}`}
							key={`${dataFieldOrBlock.entityType}_${dataFieldOrBlock.guestAttribute.dataField.id}`}
							sectionId={section.id}
							dataField={dataFieldOrBlock.guestAttribute.dataField}
							validationRules={validationRuleMap[dataFieldOrBlock.guestAttribute.dataField.id] ?? []}
							stepId={stepId}
						/>
					);
				}
			})}
		</>
	);
};
